import { render, staticRenderFns } from "./exclusiveRights.vue?vue&type=template&id=569c71d5&scoped=true&"
import script from "./exclusiveRights.vue?vue&type=script&lang=js&"
export * from "./exclusiveRights.vue?vue&type=script&lang=js&"
import style0 from "./exclusiveRights.vue?vue&type=style&index=0&id=569c71d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c71d5",
  null
  
)

export default component.exports